import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import InputField from "../../InputField";
import exportImage from "../../../asset/Images";
import { useMutation, useQuery } from "react-query";
import { branchData } from "../../../globalApi/GlobalApi";
import axios from "axios";
import Popup from "../../popupmodal/Popup";

export default function BranchCom() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const { handleSubmit, control, watch, setValue } = useForm();

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 5;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState();

  const [popupType, setPopupType] = useState({
    type: "",
    data: "",
  });

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // GET API START
  const { data, isLoading, isError, refetch } = useQuery("data", branchData, {
    refetchOnWindowFocus: false,
    enabled: false,
  });
  useEffect(() => {
    refetch();
  }, [refetch]);

  let details = (data && data?.data) || [];

  const filteredDetails = searchTerm
    ? details?.filter((item) => {
        const nameMatch = item?.categoryName
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());
        const statusMatch = item?.status
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());
        return nameMatch || statusMatch;
      })
    : details;

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  // Pagination logic
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows =
    filteredDetails && filteredDetails?.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(
    filteredDetails && filteredDetails?.length / rowsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // DELETE API

  const { mutate, isLoading: deleteLoading } = useMutation(
    async (deleteId) => {
      try {
        const response = await axios.delete(
          `${process.env.REACT_APP_HOST}/branches/${deleteId}`
        );
        return response.data;
      } catch (error) {
        console.error("Error in mutation function:", error);
        throw error; // To trigger onError
      }
    },
    {
      onSuccess: () => {
        console.log("branch deleted successfully");
        setPopupType({
          type: "delete success",
        });
        refetch(); // Refresh data after successful deletion
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to delete branch. Please try again.");
      },
    }
  );

  const handleDelete = () => {
    if (deleteId) {
      mutate(deleteId);
    } else {
      alert("No invoice selected for deletion.");
    }
  };

  // DELETE API END

  return (
    <>
      <div className="screen_mainContainer">
        <div className="screen_InnerContainer">
          <header className="screen_headerContainer">
            <div className="header_title">Branch</div>
            <div
              className="header_Btn_container"
              onClick={() => {
                navigate("/setting/branch");
              }}
            >
              Add Branch
            </div>
          </header>
          <section className="viewPageSectionContainer">
            <div className="tableMainContainer">
              <table className="tableMain">
                <thead>
                  <tr className="tableHeadRow">
                    <td
                      className="tableHeaderTxt"
                      style={{
                        width: "26%",
                      }}
                    >
                      S.No
                    </td>
                    <td
                      className="tableHeaderTxt"
                      style={{
                        width: "26%",
                      }}
                    >
                      Branch Name
                    </td>
                    <td
                      className="tableHeaderTxt"
                      style={{
                        width: "26%",
                      }}
                    >
                      Status
                    </td>

                    <td
                      className="tableHeaderTxt "
                      style={{
                        width: "300px",
                      }}
                    >
                      Action
                    </td>
                  </tr>
                </thead>
                <tbody className="tableBody">
                  {isLoading ? (
                    <>
                      {/* <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          <div className="loader"></div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr> */}
                      <h6 className="mt-3 px-3">L O A D I N G . . .</h6>
                    </>
                  ) : currentRows?.length > 0 ? (
                    currentRows &&
                    currentRows?.map((item, index) => {
                      return (
                        <tr>
                          <td
                            className="tableDataTxt"
                            style={{
                              width: "26%",
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            className="tableDataTxt"
                            style={{
                              width: "26%",
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                          >
                            {item?.branchName || "-"}
                          </td>
                          <td
                            className="tableDataTxt"
                            style={{
                              color:
                                item?.status === "Inactive" ? "red" : "green",
                              width: "26%",
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                            }}
                          >
                            {item?.status || "-"}
                          </td>

                          <td
                            className="tableDataTxt "
                            style={{
                              width: "300px",
                              backgroundColor:
                                index % 2 == 0 ? "rgba(223, 246, 255, 1)" : "",
                              //   height: "100%",
                            }}
                          >
                            <div
                              className="d-flex gap-1 align-items-center"
                              style={{
                                width: "100%",
                                backgroundColor:
                                  index % 2 == 0
                                    ? "rgba(223, 246, 255, 1)"
                                    : "",
                                //   height: "100%",
                              }}
                            >
                              <div
                                className="actionBtn"
                                onClick={() => {
                                  navigate("/setting/branch", { state: item });
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <img
                                  className="mb-1"
                                  src={exportImage?.editIcon}
                                  alt="editIcon"
                                />
                              </div>
                              <div
                                className="actionBtn"
                                onClick={() => {
                                  setIsModalOpen(true);
                                  setPopupType({
                                    ...popupType,
                                    type: "confirm delete",
                                  });
                                  setDeleteId(item?.id);
                                }}
                              >
                                <img
                                  className="mb-1"
                                  src={exportImage?.deleteIcon}
                                  alt="deleteIcon"
                                />
                              </div>
                              {/* <div className="actionBtn" onClick={() => {}}>
                                <img
                                  className="mb-1"
                                  src={exportImage?.duplicateIcon}
                                  alt="duplicateIcon"
                                />
                              </div> */}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <p className="noDataFoundTxt">No Data Found</p>
                  )}
                </tbody>
              </table>
            </div>
          </section>
          <nav aria-label="Page navigation example" className="mt-2">
            <ul className="pagination justify-content-center">
              {/* Previous Button */}
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &laquo;
                </button>
              </li>

              {/* Page Numbers */}
              {Array?.from({ length: totalPages })?.map((_, index) => {
                const pageNumber = index + 1;
                const isActive = currentPage === pageNumber;

                return (
                  <li
                    key={pageNumber}
                    className={`page-item ${isActive ? "active" : ""}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                );
              })}

              {/* Next Button */}
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  &raquo;
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <Popup
        isOpen={isModalOpen}
        closePopup={closeModal}
        popupType={popupType}
        setPopupType={setPopupType}
        handleDelete={handleDelete}
        deleteLoading={deleteLoading}
        message="Are you sure you want to delete Branch details?"
      />
    </>
  );
}
